import View from "../counter-basket/Main";
import components from "./components.js";
components.define("js-ProductBuy-changeQuantity", View);